"use client";

// Forgot password v3 — usa flow propio en vez de supabase.auth.resetPasswordForEmail.
// Server action genera token propio + manda mail vía Resend con link a
// nuestro dominio (/reset-password?t=<token>). Resuelve 3 problemas del
// flow viejo: dominio supabase.co expuesto, antivirus prefetch consumiendo
// el token, y "Auth session missing!" por PKCE cross-device. Ver mig 157
// + forgot-password/actions.ts.

import { useState } from "react";
import Link from "next/link";
import { useParams } from "next/navigation";
import { requestPasswordReset } from "./actions";
import { BrandMark } from "@/components/brand/BrandMark";
import { PublicShell } from "@/components/brand/PublicShell";

export default function ForgotPasswordPage() {
  const params = useParams<{ locale: string }>();
  const locale = params.locale ?? "es";
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true); setError(null);
    const result = await requestPasswordReset(email);
    setLoading(false);
    if ("error" in result) {
      setError(result.error);
      return;
    }
    setSent(true);
  }

  return (
    <PublicShell locale={locale}>
      {sent ? (
        <div style={{ textAlign: "center" }}>
          <div style={{
            width: 56, height: 56, borderRadius: 14,
            background: "#6C5CFF", color: "white",
            display: "grid", placeItems: "center",
            margin: "0 auto 18px",
            boxShadow: "0 8px 22px -8px rgba(108,92,255,0.6), inset 0 1px 0 rgba(255,255,255,0.3)",
          }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 6l-10 7L2 6" />
              <rect x="2" y="4" width="20" height="16" rx="2" />
            </svg>
          </div>
          <h1 className="card-title">Revisá tu email</h1>
          <p className="card-sub" style={{ marginTop: 8 }}>
            Si existe una cuenta con ese email, te enviamos un link para restablecer la contraseña.
          </p>
          <div style={{
            display: "inline-block",
            padding: "6px 12px",
            background: "#ECE8FF",
            color: "#6C5CFF",
            borderRadius: 8,
            fontFamily: "ui-monospace, monospace",
            fontSize: 13, fontWeight: 600,
            margin: "16px 0 18px",
          }}>
            {email}
          </div>
          <p style={{ fontSize: 12.5, color: "#A19FB6", lineHeight: 1.5, marginBottom: 0 }}>
            ¿No te llegó? Revisá spam o escribinos a <strong>hola@talenv.com</strong>.
          </p>
          <div className="card-foot">
            <Link href={`/${locale}/login`}>← Volver al login</Link>
          </div>
        </div>
      ) : (
        <>
          <div className="card-header">
            <div className="card-icon">
              <BrandMark size={44} rounded={11} />
              talenv
            </div>
            <h1 className="card-title">Recuperá tu contraseña</h1>
            <p className="card-sub">Te mandamos un link al email para restablecerla.</p>
          </div>

          <form onSubmit={handleSubmit} noValidate>
            <div className="field">
              <label htmlFor="email" className="field-label">Email</label>
              <input
                type="email"
                id="email"
                className="input"
                placeholder="tu@empresa.com"
                autoComplete="email"
                required
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            {error && <div className="error-box">{error}</div>}

            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? "Enviando…" : "Enviar instrucciones"}
            </button>
          </form>

          <div className="card-foot">
            <Link href={`/${locale}/login`}>← Volver al login</Link>
          </div>
        </>
      )}
    </PublicShell>
  );
}
